import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CtaButton } from './ui/CtaButton';
import { Check, X, ArrowRight } from 'lucide-react';
export function OfferSection() {
  return <section className="w-full px-4 md:px-6" data-id="element-121">
      <div className="max-w-4xl mx-auto space-y-24" data-id="element-122">
        {/* What You Receive */}
        <FadeIn data-id="element-123">
          <div className="bg-brand-card border border-brand-gold/20 rounded-2xl p-8 md:p-12" data-id="element-124">
            <h2 className="text-3xl font-bold text-white mb-8 text-center" data-id="element-125">
              Lo que recibes
            </h2>
            <div className="grid md:grid-cols-2 gap-8" data-id="element-126">
              <div className="space-y-4" data-id="element-127">
                <div className="flex gap-4" data-id="element-128">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-129">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-130" />
                  </div>
                  <div data-id="element-131">
                    <h3 className="font-bold text-white text-lg" data-id="element-132">
                      Manual del Dinero (ebook)
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-133">
                      Con capítulos profundos, ejemplos y ejercicios.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-134">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-135">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-136" />
                  </div>
                  <div data-id="element-137">
                    <h3 className="font-bold text-white text-lg" data-id="element-138">
                      Plan de implementación
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-139">
                      Paso a paso, sin teoría infinita.
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-4" data-id="element-140">
                <div className="flex gap-4" data-id="element-141">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-142">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-143" />
                  </div>
                  <div data-id="element-144">
                    <h3 className="font-bold text-white text-lg" data-id="element-145">
                      Plantillas imprimibles
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-146">
                      Mapa del Dinero, Mapa de Cuentas, Tarjeta "Rol Definido".
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-147">
                  <div className="bg-brand-gold/10 p-2 rounded-full h-fit" data-id="element-148">
                    <Check className="w-6 h-6 text-brand-gold" data-id="element-149" />
                  </div>
                  <div data-id="element-150">
                    <h3 className="font-bold text-white text-lg" data-id="element-151">
                      Protocolo Anti-Crisis
                    </h3>
                    <p className="text-brand-muted text-sm" data-id="element-152">
                      Qué hacer cuando el mundo se pone raro (sin decisiones
                      heroicas).
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Who it is for */}
        <FadeIn data-id="element-153">
          <h2 className="text-3xl font-bold text-white mb-10 text-center" data-id="element-154">
            Para quién es (y para quién no)
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-155">
            {/* YES */}
            <div className="bg-brand-green/5 border border-brand-green/20 rounded-xl p-8" data-id="element-156">
              <h3 className="text-brand-green font-bold text-xl mb-6 flex items-center gap-2" data-id="element-157">
                <Check className="w-6 h-6" data-id="element-158" /> Es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-159">
                {['Emprendes o trabajas por tu cuenta en Latinoamérica', 'Tus ingresos son variables o irregulares', 'Te afecta el ruido del dólar/noticias/tasas', 'Sientes que te falta control, no ganas', 'Quieres reglas simples, no motivación'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/90" data-id="element-160">
                    <Check className="w-4 h-4 text-brand-green mt-1 shrink-0" data-id="element-161" />
                    <span data-id="element-162">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* NO */}
            <div className="bg-brand-red/5 border border-brand-red/20 rounded-xl p-8" data-id="element-163">
              <h3 className="text-brand-red font-bold text-xl mb-6 flex items-center gap-2" data-id="element-164">
                <X className="w-6 h-6" data-id="element-165" /> No es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-166">
                {["Buscas 'la inversión del año'", 'Quieres trading o promesas de rendimiento', 'Quieres predicciones geopolíticas', 'Te molesta hacerte responsable de tus reglas'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-text/90" data-id="element-167">
                    <X className="w-4 h-4 text-brand-red mt-1 shrink-0" data-id="element-168" />
                    <span data-id="element-169">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>

        {/* Transformation */}
        <FadeIn data-id="element-170">
          <div className="text-center max-w-2xl mx-auto" data-id="element-171">
            <h2 className="text-3xl font-bold text-white mb-8" data-id="element-172">
              La transformación
            </h2>
            <p className="text-lg text-brand-muted mb-10" data-id="element-173">
              No te prometo que el mundo se calme. Te prometo algo más útil:{' '}
              <br data-id="element-174" />
              <span className="text-white" data-id="element-175">
                Que tu dinero deje de ser un lugar donde se pelean tus
                emociones.
              </span>
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-176">
              {[{
              from: 'Improvisar',
              to: 'Ejecutar'
            }, {
              from: 'Reaccionar',
              to: 'Decidir'
            }, {
              from: 'Mezclar',
              to: 'Separar'
            }, {
              from: 'Urgencia',
              to: 'Criterio'
            }].map((item, i) => <div key={i} className="flex items-center justify-between bg-brand-card p-4 rounded border border-brand-bg" data-id="element-177">
                  <span className="text-brand-muted" data-id="element-178">{item.from}</span>
                  <ArrowRight className="w-4 h-4 text-brand-gold" data-id="element-179" />
                  <span className="text-white font-bold" data-id="element-180">{item.to}</span>
                </div>)}
            </div>

            <p className="text-lg text-white font-serif italic mb-8" data-id="element-181">
              "Y cuando el entorno se mueva, tú vas a tener una ventaja: no vas
              a estar tomando decisiones desde el pánico."
            </p>

            <div className="flex justify-center" data-id="element-182">
              <CtaButton onClick={() => document.getElementById('final-cta')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-183">
                Quiero el Manual del Dinero
              </CtaButton>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}